import React, {useState, useEffect }  from 'react'
import {useHistory, useParams} from "react-router-dom"
import intl from 'react-intl-universal';
import '@/assets/css/goods.scss';
import { REQUEST } from "@/api";
import { queryString} from "@/util";

const Goods = () => {
    const [word, setWord] = useState('')
    const [query, setQuery] = useState({
        limit: 10,
        page: 1,
        type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2'
    })
    const [loadMore, setLoadMore] = useState(true)
    const [goodsList, setGoodsList] = useState([])

    const history = useHistory()
    const params = useParams()
    const goDetail = (val) => {
        history.push('/goods/' + val.goodsCode)
    }

    const resetData = () => {
        setQuery(Object.assign({}, {
            limit: 10,
            page: 1,
            type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2'
        }))
        setWord('')
    }

    const fetchGoodsList = (name) => {
        let data = {
            type: query.type,
            limit: query.limit,
            page: query.page,
            name,
            shelves: '1'
        }
        REQUEST('searchGoodsList', data).then((res) => {
            setGoodsList(goodsList => [...goodsList, ...res.body.list])
            const myQuery = query
            myQuery.page ++
            setQuery(myQuery)
            setLoadMore(res.body.list.length === query.limit)
        })
    }

    const loadMoreGoods = (more) => {
        if (!more) return
        fetchGoodsList(word)

    }

    const initData = () => {
        resetData()
        const keywords = queryString('w') || ''
        // console.log(history, keywords)
        // const word = params.w
        setWord(keywords)
        fetchGoodsList(keywords)

    }
    useEffect(() => {
        initData()
    }, [params.w])

    return (
        <div className="rl">
            <div className="rl-container rl-goods flex-column">
                <ul className="rl-goods-list search">
                    {
                        goodsList.map((val) => {
                            return (
                                <li className="rl-goods-item" key={val.id} onClick={() => goDetail(val)}>
                                    <div className="goods-item-img">
                                        <div className="img-box flex-center">
                                            <img src={val.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="goods-item-info flex-between">
                                        <div className="info-text flex-row-start">{val.goodsName}</div>
                                        <div className="info-ctr">Click it</div>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
                <div className="rl-goods-more" onClick={() => loadMoreGoods(loadMore)}>
                    {
                        loadMore ? ('加载更多') : ('没有更多')
                    }
                </div>
            </div>
        </div>
    )
}
export default Goods
